



































import { Component, Vue, Emit } from "vue-property-decorator";

@Component
export default class EventCreateCalendar extends Vue {
    public date: string = new Date().toISOString().substring(0, 7);
    public navigator = navigator;

    public get registrationLink() {
        return `${window.location.protocol}//${
            window.location.host
        }/events/calendar/${encodeURIComponent(this.userId)}/${this.date}`;
    }

    public get userId(): string {
        return this.$store.state.user.id;
    }

    public copyToClipboard(eventLink: string) {
        navigator.clipboard.writeText(eventLink);
        this.$store.commit("showSnackbar", {
            text: this.$t("event.copyToClipboard"),
            color: "success",
        });
    }
    @Emit()
    public submit(): boolean {
        return true;
    }
}
